var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPoliticalMeeting = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 37",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.387 13.865h-.307v-1.338a.84.84 0 0 0-.246-.594l-1.045-1.046a.84.84 0 0 0-1.188 1.188l.8.8v.99h-1.37v-1.073c0-1.08-.7-1.995-1.672-2.317a2.097 2.097 0 1 0-2.429-.024 2.445 2.445 0 0 0-1.748 2.342v1.073h-.098a1.08 1.08 0 0 0-1.08 1.08v3.529c0 .523.372.959.865 1.058l.686 11.055c.035.57.508 1.012 1.078 1.012h6.26a1.08 1.08 0 0 0 1.078-1.017l.636-11.05c.492-.1.862-.536.862-1.057v-3.53a1.08 1.08 0 0 0-1.08-1.08zm-1.08 2.16v1.369H7.164v-1.37zM30.498 13.973h-.099V12.9a2.44 2.44 0 0 0-1.746-2.343 2.098 2.098 0 1 0-2.435.024l-.07.024h-2.087L21.25 7.91 20.011 9.15l3.082 3.184h1.521a2.4 2.4 0 0 0-.066.567v1.072h-3.356a1.08 1.08 0 0 0-1.08 1.08v3.53c0 .501.342.921.805 1.044l.025 11.005c0 .595.484 1.078 1.08 1.078h6.98a1.08 1.08 0 0 0 1.077-1.02l.636-11.049c.492-.1.862-.536.862-1.057v-3.53a1.08 1.08 0 0 0-1.08-1.08m-1.08 3.53h-7.145v-1.37h2.91v-2.679c0-.222.087-.437.246-.594l1.045-1.045a.84.84 0 0 1 1.188 1.188l-.8.8v2.33h2.556z"
  })));
};
export default SvgPoliticalMeeting;